import { syncVanHoaCauHinhEmailMenuKeys } from './CauHinhEmailMenu';
import { AI_AGENT_BASE_PATH, AI_AGENT_MENU_ITEM, aiHubSettingsMenuKey, resolveAiHubTab } from '@/config/aiAgentMenu';

export type NavbarMenuRouteSyncOptions = {
    includeVanHoaMenus?: boolean;
    /** Chỉ highlight Action Plan V2 khi site thuộc allowlist. */
    allowActionPlanV2?: boolean;
    /** Chỉ highlight KPI không đạt khi bật Cảnh báo KPI ba kỳ liên tiếp. */
    allowKpiKhongDat?: boolean;
};

/**
 * Đồng bộ selectedKeys / openKeys của Menu sidebar Navbar theo `router.pathname` (Next.js Pages Router).
 * Giữ nguyên hành vi từng nhánh: một số route chỉ gọi setSelectedKeys, không đổi openKeys.
 */
export function syncNavbarMenuKeysFromPathname(
    pathname: string,
    asPath: string,
    setSelectedKeys: (keys: string[]) => void,
    setOpenKeys: (keys: string[]) => void,
    options?: NavbarMenuRouteSyncOptions,
): void {
    if (pathname === '/bang-ke-hoach') {
        setSelectedKeys(['bangkehoach']); // BẢNG KẾ HOẠCH
    } else     if (pathname === '/dashboard' || pathname === '/dashboard/') {
        setSelectedKeys(['dashboard']); // Dashboard
    } else if (pathname === '/dot-on-tap') {
        setSelectedKeys(['dotontap']); // Đợt ôn tập
    } else if (pathname === '/dot-on-tap/ket-qua' || pathname.startsWith('/dot-on-tap/ket-qua/')) {
        setSelectedKeys(['dotontap']);
    } else if (pathname === '/dot-on-tap/lam-bai' || pathname.startsWith('/dot-on-tap/lam-bai/')) {
        setSelectedKeys(['dotontap']);
    } else if (pathname === '/hop-tuan') {
        setSelectedKeys(['hoptuan']); // Họp tuần
    } else if (pathname.startsWith('/quy-trinh')) {
        // Triển Khai Quy Trình — khớp key trong `ProcedureStep.tsx`
        setOpenKeys([]);

        if (pathname === '/quy-trinh' || pathname === '/quy-trinh/' || pathname === '/quy-trinh/buoc2') {
            setSelectedKeys(['quy-trinh']);
        } else if (pathname === '/quy-trinh/sla') {
            setSelectedKeys(['quy-trinh-sla']);
        } else if (pathname === '/quy-trinh/sla-calendar') {
            setSelectedKeys(['quy-trinh-sla-calendar']);
        } else if (pathname === '/quy-trinh/task-inbox') {
            setSelectedKeys(['task-inbox']);
        } else if (pathname === '/quy-trinh/dashboard' || pathname === '/quy-trinh/monitoring') {
            setSelectedKeys(['quy-trinh-dashboard']);
        } else if (pathname === '/quy-trinh/analytics') {
            setSelectedKeys(['quy-trinh-analytics']);
        } else if (
            pathname === '/quy-trinh/exam-question-bank' ||
            pathname === '/quy-trinh/question-bank' ||
            pathname === '/quy-trinh/exam'
        ) {
            setSelectedKeys(['quy-trinh-exam-question-bank']);
        } else if (pathname === '/quy-trinh/curriculum') {
            setSelectedKeys(['quy-trinh-curriculum']);
        } else if (pathname === '/quy-trinh/curriculum-learn' || pathname === '/quy-trinh/chi-tiet-giao-trinh') {
            setSelectedKeys(['quy-trinh-curriculum-learn']);
        } else if (pathname === '/quy-trinh/dao-tao-quy-trinh') {
            setSelectedKeys(['quy-trinh-dao-tao-quy-trinh']);
        } else if (pathname === '/quy-trinh/legacy-migration') {
            setSelectedKeys(['quy-trinh-legacy-migration']);
        } else if (pathname === '/quy-trinh/so-do-to-chuc' || pathname === '/quy-trinh/so-do-to-chuc/') {
            setOpenKeys(['sub1']);
            setSelectedKeys(['so-do-to-chuc']);
        } else if (pathname === '/quy-trinh/quan-ly-bieu-mau' || pathname === '/quy-trinh/quan-ly-bieu-mau/') {
            setOpenKeys(['setting']);
            setSelectedKeys(['quy-trinh-quan-ly-bieu-mau']);
        } else if (pathname === '/quy-trinh/ai-rules') {
            setOpenKeys(['setting']);
            setSelectedKeys(['quy-trinh-ai-rules']);
        } else if (pathname === '/quy-trinh/email-logs' || pathname === '/quy-trinh/email-logs/') {
            setOpenKeys(['setting', 'quy-trinh-cau-hinh-email']);
            setSelectedKeys(['quy-trinh-email-logs']);
        } else if (pathname.startsWith('/quy-trinh/cau-hinh-email')) {
            setOpenKeys(['setting', 'quy-trinh-cau-hinh-email']);
            if (pathname === '/quy-trinh/cau-hinh-email/cau-hinh-smtp' ||
                pathname === '/quy-trinh/cau-hinh-email/cau-hinh-smtp/') {
                setSelectedKeys(['quy-trinh-cau-hinh-smtp']);
            } else if (
                // Highlight menu "Thời gian gửi mail" khi đang ở trang cấu hình giờ scheduler thi QT.
                pathname === '/quy-trinh/cau-hinh-email/thoi-gian-gui-mail' ||
                pathname === '/quy-trinh/cau-hinh-email/thoi-gian-gui-mail/'
            ) {
                setSelectedKeys(['quy-trinh-thoi-gian-gui-mail']);
            } else if (pathname.startsWith('/quy-trinh/cau-hinh-email/mau-mail')) {
                setSelectedKeys(['quy-trinh-email-template']);
            } else {
                setSelectedKeys(['quy-trinh-cau-hinh-email']);
            }
        } else {
            setSelectedKeys([]);
        }
    } else if (pathname === '/van-hoa/dashboard') {
        setSelectedKeys(['dashboard']);
        setOpenKeys([]);
    } else if (pathname === '/van-hoa/dot-on-tap' || pathname.startsWith('/van-hoa/dot-on-tap/')) {
        setSelectedKeys(['dotontap']);
        setOpenKeys([]);
    } else if (
        pathname === '/van-hoa/dot-danh-gia/bao-cao/[id]/hientaituonglai' ||
        pathname === '/van-hoa/dot-danh-gia/bao-cao/[id]/hien-tai-tuong-lai' ||
        pathname === '/van-hoa/dot-danh-gia/bao-cao/hientaituonglai'
    ) {
        setSelectedKeys(['bao-cao-so-sanh-van-hoa']);
        setOpenKeys(['khao-sat-van-hoa']);
    } else if (pathname === '/van-hoa/dot-danh-gia/bao-cao/[id]/gankettrainghiemdiemchamnhanvien') {
        setSelectedKeys(['dot-khao-sat-gan-ket-trai-nghiem-diem-cham-nhan-vien']);
        setOpenKeys(['danh-gia-va-trai-nghiem', 'gan-ket-trai-nghiem-diem-cham-nhan-vien']);
    } else if (pathname === '/van-hoa/dot-danh-gia/bao-cao/[id]/truongthanhvanhoa') {
        setSelectedKeys(['danh-gia-suc-khoe-doanh-nghiep', 'dot-danh-gia-suc-khoe-doanh-nghiep']);
        setOpenKeys(['danh-gia-va-trai-nghiem', 'thu-vien-van-hoa', 'khao-sat-danh-gia']);
    } else if (pathname === '/van-hoa/khao-sat/lam-bai/[id]') {
        setSelectedKeys(['khao-sat-vh-hien-tai-tuong-lai']);
        setOpenKeys(['khao-sat-van-hoa']);
    } else if (pathname.startsWith('/van-hoa/dot-danh-gia/tien-do/')) {
        const progressType = new URLSearchParams(asPath.split('?')[1] || '').get('type');
        const normalizedType = String(progressType || '').trim().toLowerCase();

        if (normalizedType === 'truong-thanh-van-hoa') {
            setSelectedKeys(['danh-gia-suc-khoe-doanh-nghiep', 'dot-danh-gia-suc-khoe-doanh-nghiep']);
            setOpenKeys(['danh-gia-va-trai-nghiem', 'thu-vien-van-hoa', 'khao-sat-danh-gia']);
        } else if (normalizedType === 'gan-ket-trai-nghiem-diem-cham-nhan-vien') {
            setSelectedKeys(['dot-khao-sat-gan-ket-trai-nghiem-diem-cham-nhan-vien']);
            setOpenKeys(['danh-gia-va-trai-nghiem', 'gan-ket-trai-nghiem-diem-cham-nhan-vien']);
        } else {
            setSelectedKeys(['khao-sat-vh-hien-tai-tuong-lai']);
            setOpenKeys(['khao-sat-van-hoa']);
        }
    } else if (pathname === '/van-hoa/dot-danh-gia/khao-sat-van-hoa-hien-tai-tuong-lai') {
        setSelectedKeys(['khao-sat-vh-hien-tai-tuong-lai', 'khao-sat-van-hoa-hien-tai-tuong-lai']);
        setOpenKeys(['khao-sat-van-hoa', 'thu-vien-van-hoa', 'khao-sat-danh-gia']);
    } else if (pathname === '/van-hoa/dot-danh-gia/dot-khao-sat-van-hoa') {
        setSelectedKeys(['khao-sat-muc-do-hieu-va-nho-van-hoa']);
        setOpenKeys(['thu-vien-van-hoa', 'khao-sat-danh-gia']);
    } else if (pathname.startsWith('/van-hoa/hinh-mau/tong-quan')) {
        setSelectedKeys(['danh-gia-hinh-mau']);
        setOpenKeys(['thu-vien-van-hoa', 'khao-sat-danh-gia']);
    } else if (pathname.startsWith('/van-hoa/hinh-mau/danh-gia')) {
        setSelectedKeys(['danh-gia-hinh-mau']);
        setOpenKeys(['thu-vien-van-hoa', 'khao-sat-danh-gia']);
    } else if (pathname === '/van-hoa/hinh-mau/lua-chon/lanh-dao') {
        setSelectedKeys(['lua-chon-hinh-mau-lanh-dao']);
        setOpenKeys(['thu-vien-van-hoa', 'tieuchi-tinh-huong-bo-cau-hoi']);
    } else if (pathname === '/van-hoa/dot-danh-gia/dot-khao-sat-truong-thanh-van-hoa') {
        setSelectedKeys(['danh-gia-suc-khoe-doanh-nghiep', 'dot-danh-gia-suc-khoe-doanh-nghiep']);
        setOpenKeys(['danh-gia-va-trai-nghiem', 'thu-vien-van-hoa', 'khao-sat-danh-gia']);
    } else if (pathname === '/van-hoa/dot-danh-gia/dot-khao-sat-gan-ket-trai-nghiem-diem-cham-nhan-vien') {
        setSelectedKeys(['dot-khao-sat-gan-ket-trai-nghiem-diem-cham-nhan-vien']);
        setOpenKeys(['danh-gia-va-trai-nghiem', 'gan-ket-trai-nghiem-diem-cham-nhan-vien']);
    } else if (pathname === '/van-hoa/tieu-chi-nhan-vien/trai-nghiem-gan-ket-diem-cham') {
        setSelectedKeys(['danh-sach-tieu-chi-gan-ket-trai-nghiem-diem-cham-nhan-vien']);
        setOpenKeys(['danh-gia-va-trai-nghiem', 'gan-ket-trai-nghiem-diem-cham-nhan-vien']);
    } else if (pathname === '/van-hoa/hinh-mau/tieu-chi/lanh-dao') {
        setSelectedKeys(['tieu-chi-hinh-mau']);
        setOpenKeys(['thu-vien-van-hoa', 'tieuchi-tinh-huong-bo-cau-hoi']);
    } else if (pathname === '/van-hoa/cau-hoi-an-le') {
        setSelectedKeys(['cau-hoi-an-le']);
        setOpenKeys(['thu-vien-van-hoa', 'tieuchi-tinh-huong-bo-cau-hoi']);
    } else if (pathname === '/van-hoa/danh-gia') {
        setSelectedKeys(['loi-the-canh-tranh-cua-doanh-nghiep']);
        setOpenKeys(['xay-dung-nen-tang']);
    } else if (pathname === '/van-hoa/ngoi-nha') {
        setSelectedKeys(['ngoi-nha-van-hoa']);
        setOpenKeys(['xay-dung-nen-tang']);
    } else if (pathname === '/van-hoa/hanh-vi-then-chot') {
        setSelectedKeys(['hanh-vi-then-chot']);
        setOpenKeys(['xay-dung-nen-tang']);
    } else if (pathname === '/van-hoa/an-le') {
        setSelectedKeys(['an-le']);
        setOpenKeys(['xay-dung-nen-tang']);
    } else if (pathname.startsWith('/van-hoa/admin')) {
        // Menu Server (admin) — keys trong `CultureStep.tsx` (`admin-van-hoa`, `admin-1`…`admin-6`)
        setOpenKeys(['admin-van-hoa']);
        if (
            pathname === '/van-hoa/admin/tieu-chi-van-hoa' ||
            pathname.startsWith('/van-hoa/admin/tieu-chi-van-hoa/')
        ) {
            setSelectedKeys(['admin-2']);
        } else if (
            pathname === '/van-hoa/admin/tieu-chi-ganket-trainghiem-diemcham' ||
            pathname.startsWith('/van-hoa/admin/tieu-chi-ganket-trainghiem-diemcham/')
        ) {
            setSelectedKeys(['admin-3']);
        } else if (
            pathname === '/van-hoa/admin/cau-hoi-an-le' ||
            pathname.startsWith('/van-hoa/admin/cau-hoi-an-le/')
        ) {
            setSelectedKeys(['admin-5']);
        } else if (
            pathname === '/van-hoa/admin/ke-hoach-hanh-dong' ||
            pathname.startsWith('/van-hoa/admin/ke-hoach-hanh-dong/')
        ) {
            setSelectedKeys(['admin-4']);
        } else if (pathname === '/van-hoa/admin/cau-hoi' || pathname.startsWith('/van-hoa/admin/cau-hoi/')) {
            setSelectedKeys(['admin-1']);
        } else if (pathname === '/van-hoa/admin/tieu-chi' || pathname.startsWith('/van-hoa/admin/tieu-chi/')) {
            setSelectedKeys(['admin-6']);
        } else {
            setSelectedKeys([]);
        }
    } else if (pathname === '/van-hoa/xuong-ca-ke-hoach') {
        setSelectedKeys(['xuong-ca-ke-hoach']);
        setOpenKeys(['bang-ke-hoach-group']);
    } else if (
        pathname === '/van-hoa/du-an' ||
        pathname.startsWith('/van-hoa/cong-viec-du-an/') ||
        pathname === '/van-hoa/quan-ly-action-plan-bo-phan'
    ) {
        setSelectedKeys(['action-plan']);
        setOpenKeys(['bang-ke-hoach-group']);
    } else if (pathname === '/van-hoa/bang-ke-hoach') {
        setSelectedKeys(['bang-ke-hoach']);
        setOpenKeys(['bang-ke-hoach-group']);
    } else if (pathname === '/van-hoa/timeline') {
        setSelectedKeys(['timeline']);
        setOpenKeys(['bang-ke-hoach-group']);
    } else if (pathname === '/danh-gia') {
        setSelectedKeys(['b1-danh-gia']); // B1 Đánh giá
        setOpenKeys(['step']);
    } else if (pathname === '/xay-dung-chien-luoc/swot') {
        setSelectedKeys(['b2-swot']); // Phân tích SWOT
        setOpenKeys(['step', 'b2-xay-dung-chien-luoc']);
    } else if (pathname === '/xay-dung-chien-luoc/chien-luoc') {
        setSelectedKeys(['b2-chien-luoc']); // Xây dựng Chiến lược
        setOpenKeys(['step', 'b2-xay-dung-chien-luoc']);
    } else if (pathname === '/ket-qua-chien-luoc/lua-chon') {
        setSelectedKeys(['b3-lua-chon']); // Lựa chọn chiến lược
        setOpenKeys(['step', 'b3-ket-qua-chien-luoc']);
    } else if (pathname === '/ket-qua-chien-luoc/ket-qua') {
        setSelectedKeys(['b3-ket-qua']); // Kết quả chiến lược
        setOpenKeys(['step', 'b3-ket-qua-chien-luoc']);
    } else if (pathname === '/ban-do-chien-luoc-thanh-phan') {
        setSelectedKeys(['b4-thanh-phan']); // Thành phần
        setOpenKeys(['step', 'b4-ban-do-chien-luoc']);
    } else if (pathname === '/ban-do-chien-luoc') {
        setSelectedKeys(['b4-cong-ty']); // Công ty
        setOpenKeys(['step', 'b4-ban-do-chien-luoc']);
    } else if (pathname === '/buoc5') {
        setSelectedKeys(['b5-mo-hinh-xuong-ca']); // Mô hình Xương cá
        setOpenKeys(['step']);
    } else if (pathname === '/buoc6' || pathname.startsWith('/buoc6/')) {
        setSelectedKeys(['b6-do-luong-chi-tieu']); // Đo lường & chỉ tiêu
        setOpenKeys(['step']);
    } else if (pathname === '/buoc7') {
        setSelectedKeys(['b7-phan-bo-ti-trong']); // Phân bổ Tỉ trọng
        setOpenKeys(['step']);
    } else if (pathname === '/du-an') {
        setSelectedKeys(['b8-action-plan']); // Action plan
        setOpenKeys(['step']);
    } else if (pathname === '/action-plan-v2' || pathname.startsWith('/action-plan-v2/')) {
        if (options?.allowActionPlanV2) {
            setSelectedKeys(['b8-action-plan-v2']); // Action plan V2
            setOpenKeys(['step']);
        }
    } else if (pathname === '/bao-cao-kpis') {
        setSelectedKeys(['report']); // Báo cáo KPIs
        setOpenKeys(['report']);
    } else if (pathname === '/thong-ke-bao-cao-kpis') {
        setSelectedKeys(['statistic']); // Thống kê báo cáo KPIs
        setOpenKeys(['statistic']);
    } else if (pathname === '/thong-ke-kpi-khong-dat' || pathname === '/thong-ke-kpi-khong-dat/') {
        if (options?.allowKpiKhongDat) {
            setSelectedKeys(['kpi-khong-dat']);
            setOpenKeys(['kpi-khong-dat']);
        }
    } else if (pathname === '/tong-hop-ca-nhan') {
        setSelectedKeys(['sumary']); // Tổng hợp
        setOpenKeys(['sumary']);
    } else if (pathname === '/database') {
        setSelectedKeys(['database']); // Database
        setOpenKeys(['database']);
    } else if (pathname === '/backup-bao-cao') {
        setSelectedKeys(['backup-bao-cao']); // Backup báo cáo
        setOpenKeys(['backup-bao-cao']);
    } else if (pathname === '/chuyen-du-lieu') {
        setSelectedKeys(['chuyen-du-lieu']); // Chuyển dữ liệu
        // setOpenKeys(['tl']);
    } else if (pathname === '/giai-doan') {
        setSelectedKeys(['giai-doan']); // Giai đoạn
        setOpenKeys(['sub6']); // Mở submenu "Thiết lập"
    } else if (pathname === '/kien-thuc-loai') {
        setSelectedKeys(['kien-thuc-loai']); // Kiến thức loại
        setOpenKeys(['sub4']);
    } else if (pathname === '/huong-dan') {
        setSelectedKeys(['huong-dan']); // Hướng dẫn
        setOpenKeys(['sub4']);
    } else if (pathname === '/van-hoa/huong-dan') {
        setSelectedKeys(['van-hoa-huong-dan']);
        setOpenKeys(['setting']);
    } else if (pathname === '/huong-dan-admin') {
        setSelectedKeys(['huong-dan-admin']); // Quản lý hướng dẫn
        setOpenKeys(['sub4']);
    } else if (pathname === '/cau-hinh') {
        setSelectedKeys(['cau-hinh']); // Cấu hình hệ thống
        setOpenKeys(['sub4']);
    } else if (pathname === '/thiet-lap/cau-hinh') {
        if (options?.includeVanHoaMenus) {
            setSelectedKeys(['van-hoa-cau-hinh']);
            setOpenKeys(['setting']);
        }
    } else if (pathname === '/van-hoa/cau-hinh') {
        setSelectedKeys(['van-hoa-cau-hinh']);
        setOpenKeys(['setting']);
    } else if (pathname === '/van-hoa/cau-hinh/thoigiankhaosat') {
        setSelectedKeys(['thoigiankhaosat']);
        setOpenKeys(['setting', 'vanHoathangDo']);
    } else if (pathname === '/van-hoa/thang-do') {
        setSelectedKeys(['thangdo-danhgia']);
        setOpenKeys(['setting', 'vanHoathangDo']);
    } else if (pathname === '/van-hoa/don-vi') {
        setSelectedKeys(['thangdo-congviec']);
        setOpenKeys(['setting', 'vanHoathangDo']);
    } else if (
        pathname === '/thiet-lap/don-vi-do-luong' ||
        pathname === '/van-hoa/thiet-lap/don-vi-do-luong'
    ) {
        setSelectedKeys(['don-vi-do-luong']); // Đơn vị đo lường
        setOpenKeys(['sub4']);
    } else if (
        pathname === '/thiet-lap/api-sync-data' ||
        pathname === '/van-hoa/thiet-lap/api-sync-data'
    ) {
        setSelectedKeys(['api-sync-data']);
        setOpenKeys(['api']);
    } else if (
        pathname === '/thiet-lap/api-co-cau' ||
        pathname === '/van-hoa/thiet-lap/api-co-cau'
    ) {
        setSelectedKeys(['api-co-cau']); // API cơ cấu
        setOpenKeys(['api']);
    } else if (
        pathname === '/thiet-lap/api-co-cau/thong-bao' ||
        pathname === '/van-hoa/thiet-lap/api-co-cau/thong-bao'
    ) {
        setSelectedKeys(['api-co-cau-thong-bao']);
        setOpenKeys(['api']);
    } else if (pathname === '/thiet-lap/api-url-whitelist') {
        setSelectedKeys(['api-url-whitelist']);
        setOpenKeys(['api']);
    } else if (pathname === '/role-group' || pathname === '/van-hoa/role-group') {
        setSelectedKeys(['nhom-quyen']); // Nhóm quyền
        setOpenKeys(['sub1']);
    } else if (pathname === '/role-approve' || pathname === '/van-hoa/role-approve') {
        setSelectedKeys(['quyen-xet-duyet']); // Quyền xét duyệt
        setOpenKeys(['sub1']);
    } else if (pathname === '/to-chuc/bo-phan' || pathname === '/van-hoa/to-chuc/bo-phan') {
        setSelectedKeys(['phong-ban']); // Phòng ban
        setOpenKeys(['sub1']);
    } else if (pathname === '/to-chuc/chuc-vu' || pathname === '/van-hoa/to-chuc/chuc-vu') {
        setSelectedKeys(['chuc-vu']); // Chức vụ
        setOpenKeys(['sub1']);
    } else if (
        pathname === '/to-chuc/nhan-vien' ||
        pathname === '/van-hoa/to-chuc/nhan-vien'
    ) {
        setSelectedKeys(['nhan-vien']); // Nhân viên
        setOpenKeys(['sub1']);
    } else if (pathname === '/to-chuc/nghi-phep') {
        setSelectedKeys(['nghi-phep']); // Nghỉ phép
        setOpenKeys(['sub1']);
    } else if (pathname === '/ckeditor') {
        setSelectedKeys(['ckeditor']); // CKEditorDemo
        setOpenKeys([]);
    } else if (pathname === '/kpi-chung') {
        setSelectedKeys(['kpi-chung']); // KPIs Chung
        setOpenKeys(['sub5']); // Mở submenu "Thư viện KPIs"
    } else if (pathname === '/kpi-ngoai-le') {
        setSelectedKeys(['kpi-ngoai-le']); // KPIs ngoại lệ
        setOpenKeys(['sub5']);
    } else if (pathname === '/kpiipoo') {
        setSelectedKeys(['kpiipoo']);
        setOpenKeys(['sub5']);
    } else if (pathname === '/thu-vien-kpi') {
        setSelectedKeys(['thu-vien-kpi']); // Danh sách KPIs
        setOpenKeys(['sub5']);
    } else if (pathname === '/hieu-suat-kpi') {
        setSelectedKeys(['hieu-suat-kpi']); // Ngắt hiệu suất KPI
        setOpenKeys(['sub5']);
    } else if (pathname === '/kpi-cong-thuc') {
        setSelectedKeys(['kpi-cong-thuc']); // Công thức KPI
        setOpenKeys(['sub6']); // Mở submenu "Cấu hình thang đo"
    } else if (pathname === '/cau-hinh-chung') {
        setSelectedKeys(['cau-hinh-chung']); // Cấu hình toàn cục
        setOpenKeys(['sub6']); // Mở submenu "Cấu hình thang đo"
    } else if (pathname === '/logfiles') {
        setSelectedKeys(['logfiles']); // File Logs
        setOpenKeys([]);
    } else if (pathname === '/van-hoa/logfiles' || pathname === '/van-hoa/logfiles/') {
        setSelectedKeys(['van-hoa-logfiles']);
        setOpenKeys([]);
    } else if (
        options?.includeVanHoaMenus &&
        syncVanHoaCauHinhEmailMenuKeys(pathname, setSelectedKeys, setOpenKeys)
    ) {
        return;
    } else if (pathname === '/cau-hinh-email/thoi-gian-gui-mail') {
        setSelectedKeys(['thoi-gian-gui-mail']);
        setOpenKeys(['sub8']);
    } else if (pathname === '/cau-hinh-email/cau-hinh-smtp') {
        setSelectedKeys(['cau-hinh-smtp']);
        setOpenKeys(['sub8']);
    } else if (pathname === '/cau-hinh-email/mau-mail' || pathname.startsWith('/cau-hinh-email/mau-mail/')) {
        setSelectedKeys(['email-template']);
        setOpenKeys(['sub8']);
    } else if (pathname === '/thiet-lap/license') {
        setSelectedKeys(['cau-hinh-license']);
        setOpenKeys(['sub6']);
    } else if (pathname === '/thiet-lap/thong-bao-he-thong') {
        setSelectedKeys(['thong-bao-he-thong']);
        setOpenKeys(['setting']);
    } else if (pathname === AI_AGENT_BASE_PATH || pathname.startsWith(`${AI_AGENT_BASE_PATH}/`)) {
        // AI Agent Hub — menu con «Cài đặt AI Agent» (nhóm Cấu hình sub6) theo ?tab=
        const tab = new URLSearchParams(asPath.split('?')[1] ?? '').get('tab');
        const key = resolveAiHubTab(tab) ?? 'overview';
        setSelectedKeys([aiHubSettingsMenuKey(key)]);
        setOpenKeys([AI_AGENT_MENU_ITEM.key]); // menu cấp 1 (dưới «Thiết lập ngôn ngữ»)
    } else if (
        pathname === '/thiet-lap/languages' ||
        pathname === '/van-hoa/thiet-lap/languages'
    ) {
        setSelectedKeys(['languages']);
        setOpenKeys(['ngon-ngu']);
    } else if (pathname === '/thiet-lap/resources') {
        setSelectedKeys(['resources']);
        setOpenKeys(['ngon-ngu']);
    } else {
        setSelectedKeys([]);
        setOpenKeys([]);
    }
}
